import axios from 'axios'
import request from '../utils/request'
export function getAction(url, data,hashader=true) {
  return request({
    url: url,
    method: 'get',
    hashader:!hashader,
    params: {
      //    tenantId: process.env.VUE_APP_CLIENT_ID,
      ...data
    }
  })
}

export function postAction(url, data) {
  return request({
    url: url,
    // url: url + (url.indexOf('?') === -1 ? '?' : '&') + 'tenantId=' + process.env.VUE_APP_CLIENT_ID,
    method: 'post',
    data: {
      ...data
    }
  })
}
export function putAction(url, data) {
  return request({
    url: url,
    // url: url + (url.indexOf('?') === -1 ? '?' : '&') + 'tenantId=' + process.env.VUE_APP_CLIENT_ID,
    method: 'put',
    data: {
      ...data
    }
  })
}
export function delAction(url, data) {
  return request({
    url: url,
    method: 'delete',
    params: {
      //    tenantId: process.env.VUE_APP_CLIENT_ID,
      ...data
    }
  })
}

// 文件上传
export function uploadFiles(url, formData,uploader) {
  return request({
    url: url,
    method: 'post',
    data: formData,
    ContentType: 'multipart/form-data', // 增加属性
    onUploadProgress: progressEvent => {
      let percent=(progressEvent.loaded / progressEvent.total * 100) | 0
      //调用onProgress方法来显示进度条，需要传递个对象 percent为进度值
      uploader.onProgress({percent:percent})
    }
  })
}

// 文件下载
export function exportAction(url, parameter) {
  return request({
    url: url,
    method: 'get',
    data: parameter,
    responseType: 'blob'
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js